import 'moment-timezone';

export const getStaticPlansSchema = dealer => ({
  definitions: {
    content: {
      title: 'Content',
      type: 'array',
      items: {
        type: 'object',
        required: ['headline', 'term', 'cost'],
        properties: {
          headline: {
            type: 'string',
            title: 'Subtitle',
            maxLength: 100,
          },
          term: {
            type: 'string',
            title: 'Term',
            maxLength: 150,
          },
          deductible: {
            type: 'number',
            title: 'Deductible',
          },
          cost: {
            type: 'number',
            title: 'Cost',
          },
        },
      },
    },
    body: {
      type: 'array',
      items: {
        type: 'object',
        required: ['title', 'content'],
        properties: {
          title: {
            type: 'string',
            title: 'Title',
            maxLength: 100,
          },
          content: {
            $ref: '#/definitions/content',
          },
        },
      },
    },
  },
  title: 'Protection Plans',
  type: 'object',
  properties: {
    protectionPlans: {
      type: 'object',
      title: '',
      properties: {
        New: {
          type: 'object',
          title: '',
          properties: {
            purchase: {
              title: 'New Vehicle - Purchase',
              $ref: '#/definitions/body',
            },
            cash: {
              title: 'New Vehicle - Cash',
              $ref: '#/definitions/body',
            },
            lease: {
              title: 'New Vehicle - Lease',
              $ref: '#/definitions/body',
            },
          },
        },
        Used: {
          type: 'object',
          title: '',
          properties: {
            purchase: {
              title: 'Used Vehicle - Purchase',
              $ref: '#/definitions/body',
            },
            cash: {
              title: 'Used Vehicle - Cash',
              $ref: '#/definitions/body',
            },
          },
        },
        ...(dealer?.featureConfig?.useCPO?.enabled && {
          CPO: {
            type: 'object',
            title: '',
            properties: {
              purchase: {
                title: 'CPO Vehicle - Purchase',
                $ref: '#/definitions/body',
              },
              cash: {
                title: 'CPO Vehicle - Cash',
                $ref: '#/definitions/body',
              },
            },
          },
        }),
      },
    },
  },
});
